// extracted by mini-css-extract-plugin
export default {"hero_img":"Carousel_hero_img__ieVoM"};